import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCkeditor from 'vue-ckeditor2';

import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

Vue.config.productionTip = false

Vue.use(VueCkeditor)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
